var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjTempo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2591_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 7.87402C18.1611 7.87402 21.1277 10.8406 21.1277 14.5004C21.1277 18.1601 18.1611 21.1267 14.5013 21.1267C10.8416 21.1267 7.875 18.1601 7.875 14.5004C7.875 10.8406 10.8416 7.87402 14.5013 7.87402ZM14.5013 10.5246C14.3256 10.5246 14.1571 10.5944 14.0328 10.7186C13.9085 10.8429 13.8387 11.0115 13.8387 11.1872V14.5004C13.8387 14.6761 13.9086 14.8446 14.0329 14.9688L16.0208 16.9568C16.1457 17.0775 16.3131 17.1442 16.4869 17.1427C16.6606 17.1412 16.8268 17.0715 16.9497 16.9487C17.0725 16.8258 17.1422 16.6596 17.1437 16.4859C17.1452 16.3121 17.0784 16.1448 16.9577 16.0198L15.164 14.226V11.1872C15.164 11.0115 15.0942 10.8429 14.9699 10.7186C14.8456 10.5944 14.6771 10.5246 14.5013 10.5246Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2591_2698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9032,
    height: 15.9032,
    fill: "white",
    transform: "translate(6.54883 6.54883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjTempo);
export default __webpack_public_path__ + "static/media/IconProjTempo.a8765831e83dfa3c12db04c57a5cb3e2.svg";
export { ForwardRef as ReactComponent };